var map = {
	"./bg.png": "dc97",
	"./bg_landing1.png": "3949",
	"./bg_landing2.png": "4007",
	"./bg_nav.png": "9b4b",
	"./book-icon.png": "e5e5",
	"./cardiology.png": "1124",
	"./clinical-pharmacology.png": "afd2",
	"./dark-email.png": "c596",
	"./dark_logo.png": "7f0d",
	"./endocrinology.png": "e0fa",
	"./gastroenterology.png": "adca",
	"./hematology.png": "7e3e",
	"./hematology2.png": "8d71",
	"./icon.png": "f0fc",
	"./light-email.png": "a6be",
	"./logo.png": "4ffd",
	"./logo/logo-hematology.png": "e229",
	"./logo/logo-management.png": "f141",
	"./logo/logo-oncology.png": "5e30",
	"./logo/logo-pulmonology.png": "961f",
	"./management.png": "e015",
	"./oncology.png": "e2bd",
	"./partners/1.png": "c37a",
	"./partners/10.png": "f112",
	"./partners/2.png": "3ec1",
	"./partners/26.png": "d47b",
	"./partners/3.png": "2596",
	"./partners/30.png": "e5d5",
	"./partners/4.png": "b0bb",
	"./partners/40.png": "1f3e",
	"./partners/41.png": "01df",
	"./partners/5.png": "14d6",
	"./partners/6.png": "7f27",
	"./partners/7.png": "a7c8",
	"./partners/8.png": "c8c8",
	"./partners/9.png": "7de3",
	"./partners/aop.png": "53e2",
	"./partners/janssen.png": "9277",
	"./partners/roche.png": "a814",
	"./partners/teva.png": "e8e2",
	"./patient-email.png": "4073",
	"./pulmonology.png": "96c7",
	"./rheumatology.png": "a315",
	"./sponsors/amgen.png": "84af",
	"./sponsors/astrazeneca.png": "de17",
	"./sponsors/janssen.png": "abc6",
	"./sponsors/msd.png": "f56e",
	"./sponsors/pfizer.png": "c94f",
	"./sponsors/pfizer2021.png": "9b30",
	"./sponsors/roche.png": "280f",
	"./sponsors/teva.png": "6f6d",
	"./therapy.png": "5405",
	"./user.png": "0f71",
	"./video-thumbs/349.png": "35b5",
	"./video-thumbs/thumb1.png": "c483"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";